export default "__VITE_ASSET__CUY_plaA__"